import { action } from 'typesafe-actions';
import { contactDPOTLogadoTypes } from './types';

interface Contact {
  email: string;
  identification_key: string;
  ownership_type?: number | string | null;
  country_company?: number | string;
  subject?: number | string;
  content?: string;
  recaptcha?: string;
  file?: File[];
}

export const contactDPORequest = (contactDPO: Contact) =>
  action(contactDPOTLogadoTypes.CONTACT_DPO_RESQUEST, { contactDPO });

export const contactDPOSuccess = () =>
  action(contactDPOTLogadoTypes.CONTACT_DPO_SUCCESS, {});

export const contactDPOFailure = () =>
  action(contactDPOTLogadoTypes.CONTACT_DPO_FAILURE, {});

export const assuntoContactRequest = (company: any) =>
  action(contactDPOTLogadoTypes.ASSUNTO_CONTACT_RESQUEST, { company });

export const assuntoContactSuccess = (data: any) =>
  action(contactDPOTLogadoTypes.ASSUNTO_CONTACT_SUCCESS, { data });

export const assuntoContactFailure = () =>
  action(contactDPOTLogadoTypes.ASSUNTO_CONTACT_FAILURE, {});
